export const REVENUE_INTELLIGENCE_PLANNER_TIMEOUT_MS = 25_000;
export const REVENUE_INTELLIGENCE_COMPOSER_TIMEOUT_MS = 12_000;

export async function runRevenueIntelligenceChatRequest<T>(
  request: (signal: AbortSignal) => PromiseLike<T>,
  timeoutMs: number,
): Promise<T> {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      controller.abort();
      reject(new DOMException("Revenue Intelligence request timed out.", "AbortError"));
    }, timeoutMs);
  });

  try {
    return await Promise.race([
      Promise.resolve(request(controller.signal)),
      timeout,
    ]);
  } finally {
    if (timeoutId !== null) clearTimeout(timeoutId);
  }
}
